<template>
  <div>
    <el-input
      v-model="query.spuName"
      clearable=""
      style="margin-bottom: 10px;"
      placeholder="输入SPU名称搜索">
      <el-button
        slot="append"
        icon="el-icon-search"
        @click="handleCurrentChange(1)"></el-button>
    </el-input>
    <el-table
      v-loading="loading"
      highlight-current-row
      border
      height="500px"
      :data="list">
      <el-table-column
        label="SPU名称"
        min-width="200"
        prop="spuName"></el-table-column>
      <el-table-column
        label="操作"
        width="80">
        <template slot-scope="{ row }">
          <el-link
            type="primary"
            @click="selectItem(row)">{{ row.spuId === config.spuId ? '已选择' : '选择' }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <pagination-new
      v-model="query"
      :total="total"
      :fetch="fetchList" />
  </div>
</template>
<script>
import CustomApi from '@/service/custom'
export default {
  name: 'AttrTable',
  props: {
    orderSource: { type: Number },
    config: { type: Object, default() { return { categoryId: null, categoryName: '', items: [], blandId: null, blandName: '', spuId: null, spuName: '' } } }
  },
  data() {
    return { loading: false, total: 0, query: { pageNum: 1, pageSize: 10, spuName: '' }, list: [] }
  },
  methods: {
    selectItem(row) {
      const { spuId, spuName } = row
      this.$emit('update', { spuId, spuName }, 3)
    },
    handleCurrentChange(val) {
      this.query.pageNum = val
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      const { blandId, categoryId } = this.config
      const yhbV3Registered = this.orderSource === 2 ? 1 : null
      CustomApi.getappraisalspus({ ...this.query, blandId, categoryId, yhbV3Registered })
        .then(res => {
          this.loading = false
          const { records, result, message, total } = res.data
          if ([0, -13].includes(result)) {
            this.total = total
            this.list = records.map(i => ({ spuId: i.id, spuName: i.spuName }))
          } else {
            this.$message.error(message)
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error(err.message)
        })
    }
  }
}
</script>
